import React from 'react'

import {
  Box,
  Chip,
  FormControl,
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@material-ui/core'
import { isEmpty } from 'lodash'

import { EvidenceCard } from './components'

import helpers from 'helpers'
import suppliersConstants from 'constants/suppliers/companySuppliers'
import useStyles from './styles'

const { PENDING_STATUS, QUIZ_STATUS_COLOR, QUIZ_STATUS_LABEL } =
  suppliersConstants

const QuestionCard = ({ template, setDownloading }) => {
  const chipStatus = template?.answer
    ? template?.answer?.status || PENDING_STATUS
    : PENDING_STATUS

  const classes = useStyles({ chipColor: QUIZ_STATUS_COLOR[chipStatus] })

  const evidences = helpers.questionnaires.resolveEvidences(
    template?.answer,
    template,
  )

  return (
    <Paper
      component={Box}
      display="flex"
      flexDirection="column"
      overflow="hidden"
    >
      <Box
        display="flex"
        alignItems="flex-start"
        flexWrap="wrap"
        gridGap={8}
        p={2}
        className={classes.questionHeader}
      >
        <Box
          display="flex"
          flexDirection="column"
          gridGap={4}
          className={classes.themeText}
        >
          <Typography variant="h4" color="primary">
            {template?.theme}
          </Typography>
          <Typography variant="subtitle1" color="primary">
            {template?.question}
          </Typography>
          {template?.explanation && (
            <Typography variant="body1" color="primary">
              {template.explanation}
            </Typography>
          )}
        </Box>

        <Box
          display="flex"
          flexDirection="column"
          alignItems="flex-end"
          gridGap={4}
          className={classes.statusBlock}
        >
          <Chip
            size="small"
            label={QUIZ_STATUS_LABEL[chipStatus]}
            className={classes.statusChip}
          />
          {template?.answer?.answeredBy && (
            <Typography variant="caption" color="textSecondary" align="right">
              <strong>{template.answer.answeredBy}</strong>
            </Typography>
          )}
          {template?.answer?.updatedAt && (
            <Typography variant="caption" color="textSecondary" align="right">
              <strong>
                {helpers.formatters.ptBrFormatDateTime(
                  template.answer.updatedAt,
                )}
              </strong>
            </Typography>
          )}
        </Box>
      </Box>

      <Box p={2} display="flex" flexDirection="column" gridGap={16}>
        <Box
          display="flex"
          flexDirection="column"
          gridGap={4}
          className={classes.answerSection}
        >
          <Typography variant="h6" color="primary">
            Resposta do Fornecedor
          </Typography>
          <FormControl>
            <RadioGroup
              value={String(template?.answer?.questionAlternativeId ?? '')}
            >
              {template?.questionAlternatives?.map((alternative) => (
                <FormControlLabel
                  key={alternative.id}
                  value={String(alternative.id)}
                  disabled
                  control={<Radio color="primary" />}
                  label={
                    <Typography
                      variant="body1"
                      className={
                        alternative.id ===
                        template?.answer?.questionAlternativeId
                          ? classes.selectedAlternative
                          : classes.unselectedAlternative
                      }
                    >
                      {alternative.title}
                    </Typography>
                  }
                />
              ))}
            </RadioGroup>
          </FormControl>
        </Box>

        {template?.answer?.justification && (
          <Box className={classes.answerSection}>
            <TextField
              label="Justificativa (comentário)"
              value={template.answer.justification}
              variant="outlined"
              fullWidth
              multiline
              minRows={3}
              disabled
            />
          </Box>
        )}

        {!isEmpty(evidences) && (
          <Box
            display="flex"
            flexDirection="column"
            gridGap={8}
            className={classes.answerSection}
          >
            <Typography variant="h6" color="primary">
              Evidências Exigidas:
            </Typography>
            {evidences.map((evidence) => (
              <EvidenceCard
                key={evidence.id}
                evidence={evidence}
                setDownloading={setDownloading}
              />
            ))}
          </Box>
        )}
      </Box>
    </Paper>
  )
}

export default QuestionCard
